import EventStatusMessage from '../../EventStatusMessage/EventStatusMessage';

const ESportsScoreboardInPlayStatus: React.FC = () => (
  <EventStatusMessage messageId="IN_PLAY" iconName="in-play" size="XSmall" />
);

export default ESportsScoreboardInPlayStatus;
